var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.002 18.0276L21.0155 15.0141C21.7965 14.2331 23.0629 14.2331 23.8439 15.0141C24.625 15.7952 24.625 17.0615 23.8439 17.8425L17.4153 24.2711C16.6343 25.0522 15.368 25.0522 14.5869 24.2711L8.15833 17.8425C7.37728 17.0615 7.37728 15.7952 8.15833 15.0141C8.93938 14.2331 10.2057 14.2331 10.9868 15.0141L14.002 18.0293L14.002 5.19774C12.6308 5.47926 11.365 6.06099 10.2045 6.94294C8.5 8.2384 7.36364 9.93158 6.79545 12.0225C5.06818 12.4089 3.67045 13.2952 2.60227 14.6816C1.53409 16.0679 1 17.6475 1 19.4202C1 21.4884 1.73318 23.2384 3.19955 24.6702C4.665 26.102 6.43182 26.8179 8.5 26.8179H24.8636C26.5682 26.8179 28.0173 26.2216 29.2109 25.0289C30.4036 23.8352 31 22.3861 31 20.6816C31 19.1134 30.4832 17.7439 29.4495 16.5729C28.415 15.4029 27.1136 14.727 25.5455 14.5452C25.5455 11.8861 24.6191 9.63022 22.7664 7.77749C21.3985 6.4096 19.8103 5.54692 18.002 5.18945L18.002 18.0276Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadsIcon);
export default __webpack_public_path__ + "static/media/Downloads_icon.7a4bdc6b5b90d9bf3da111bca73dc5fc.svg";
export { ForwardRef as ReactComponent };